import { formatDate } from "./format-date";

/** A ledger maturity is a SQL DATE, including legacy Eloquent ISO serialization. */
export function formatFinanceDate(value: string): string {
  if (!value) return "";
  return formatDate(value.slice(0, 10), false, true);
}
